export { default } from './AttributesDrawer';
